import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import { useWindowWidth } from "../utils/useWidth";
import CinqueTerreImg from "../assets/img/cinqueTerre.webp";
import PortoVenereImg from "../assets/img/portoVenere.webp";
import { dissolvenza, VISTA } from "../utils/motionPresets";

function Activities() {
  const { t } = useTranslation();
  // eslint-disable-next-line no-unused-vars
  const width = useWindowWidth();

  const activities = [
    {
      header: t("activities.mustVisit"),
      title: t("activities.cinqueTerre"),
      description: t("activities.cinqueTerreDesc"),
      imageUrl: CinqueTerreImg,
      button: (
        <Link
          className="inline-block mt-2 border border-lux-accent text-lux-accent text-xs font-semibold uppercase tracking-widest px-5 py-2.5 rounded-sm bg-transparent hover:bg-lux-accent hover:text-white transition-colors duration-300"
          to="/cinque-terre"
        >
          {t("activities.exploreCinqueTerre")}
        </Link>
      ),
    },
    {
      header: t("activities.nearbyGems"),
      title: t("activities.portoVenere"),
      description: t("activities.portoVenereDesc"),
      imageUrl: PortoVenereImg,
      button: (
        <Link
          className="inline-block mt-2 border border-lux-accent text-lux-accent text-xs font-semibold uppercase tracking-widest px-5 py-2.5 rounded-sm bg-transparent hover:bg-lux-accent hover:text-white transition-colors duration-300"
          to="/tourist-informations"
        >
          {t("activities.explorePortoVenere")}
        </Link>
      ),
    },
  ];

  return (
    <section
      id="activities"
      className="bg-lux-bg px-10 pt-4 pb-10 flex flex-col items-center justify-center space-y-10 anchor"
    >
      <div className="flex flex-col items-center mt-6 mb-10">
        <h1 className="font-sans text-lux-accent text-[16px] font-bold tracking-widest">
          {t("activities.exploreArea")}
        </h1>
        <h1 className="text-lux-cream text-[32px] md:text-[40px] font-medium tracking-wide text-center">
          {t("activities.thingsToDo")}
        </h1>
      </div>
      {activities.map((activity, index) => (
        <div
          key={index}
          className="flex flex-col md:flex-row w-full max-w-[1500px] items-center justify-between space-y-6 md:space-y-0"
        >
          <motion.div
            variants={dissolvenza}
            initial="nascosto"
            whileInView="visibile"
            viewport={VISTA}
            className={`w-full md:w-1/2 h-56 md:h-[380px] flex-shrink-0 overflow-hidden ${
              index % 2 !== 0 ? "md:order-last md:ml-6" : "md:mr-6"
            }`}
          >
            <img
              src={activity.imageUrl}
              alt={activity.title}
              loading="lazy"
              decoding="async"
              className="w-full h-full object-cover saturate-[.75] contrast-[.95] hover:saturate-100 transition-all duration-500"
            />
          </motion.div>

          <motion.div
            className="w-full md:w-1/2 bg-lux-surface border border-lux-muted p-8 text-center md:text-left"
            variants={dissolvenza}
            initial="nascosto"
            whileInView="visibile"
            custom={1}
            viewport={VISTA}
          >
            <h2 className="font-sans text-lxl text-lux-accent font-semibold tracking-widest">
              {activity.header}
            </h2>
            <h3 className="text-3xl mt-1 mb-4 text-lux-cream font-medium tracking-wide">
              {activity.title}
            </h3>
            <p className="mt-2 text-lux-cream/80">
              {activity.description}
            </p>
            <div className="mt-3 flex justify-center md:justify-start">{activity.button}</div>
          </motion.div>
        </div>
      ))}

      <div className="flex justify-center mt-10">
        <button
          onClick={() => document.getElementById("structures")?.scrollIntoView({ behavior: "smooth" })}
          className="inline-flex items-center gap-2 border border-lux-accent text-lux-accent text-sm font-semibold px-7 py-3 rounded-sm bg-transparent hover:bg-lux-accent hover:text-lux-bg transition-all duration-300"
        >
          {t("common.discoverStructures")} →
        </button>
      </div>
    </section>
  );
}

export default Activities;
